<template lang="pug">
  .onepage-wrap
    //- 有 full-screen class 的 區塊，會計算容器高度自動滿版
    section.full-screen.home
      img#bg-human(v-lazy="homeImages.humanImage")
      img#bg-title(v-lazy="homeImages.titleImage")
      img.btn-scroll(v-if="!isMobile", src="~assets/btn-scroll.png")
      //- iframe(:width="videoWidth", :height="videoHeight", src="https://www.youtube.com/embed/Lw7D9NtqrYo", frameborder="0", allowfullscreen)
      .banner-shop
        div(@click="videoSwitch = !videoSwitch")
          //- img(src="http://i3.ytimg.com/vi/Lw7D9NtqrYo/maxresdefault.jpg", width="193", style="margin-bottom: 12px;")
          //- img(src="https://i.ytimg.com/vi/wKPcFEPUeTU/hqdefault.jpg", width="193", style="margin-bottom: 12px;")
          img(src="~assets/banner-KeP.png", width="193", style="margin-bottom: 12px;")
        router-link(:to="{name: 'shopping'}", target="_blank")
          img(src="~assets/banner-shop.png")
      .video-pop(v-if="videoSwitch")
        .bg(@click="videoSwitch = !videoSwitch")
        .video-wrap
          //- iframe(:width="videoWidth", :height="videoHeight", src="https://www.youtube.com/embed/Lw7D9NtqrYo?rel=0&amp;showinfo=0", frameborder="0", gesture="media", allowfullscreen)
          //- iframe(:width="videoWidth", :height="videoHeight", src="https://www.youtube.com/embed/wKPcFEPUeTU?rel=0&amp;showinfo=0&controls=0", frameborder="0", gesture="media", allowfullscreen)
          iframe(:width="videoWidth", :height="videoHeight", src="https://www.youtube.com/embed/wKPcFEPUeTU?rel=0&amp;showinfo=0", frameborder="0", gesture="media", allowfullscreen)
          .video-close(@click="videoSwitch = !videoSwitch") 關閉影片
    section.CountDown-wrap
      .container
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 距離 WirForce 還有 ...
        countdown.countDownTimer(:time='countDownTimer')
          template(scope='props')
            span.timerNum {{ props.days }}
            span.timerText 天
            span.timerNum {{ props.hours }}
            span.timerText 小時
            span.timerNum {{ props.minutes }}
            span.timerText 分鐘
            span.timerNum {{ props.seconds }}
            span.timerText 秒

    section.buying-process
      .container
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 什麼是 WirForce？
        p 臺灣也有自己的 Lan Party！歡迎來到 WirForce 2017！本次 BYOC 座位將會擴增超過 1,000 席，同時各大知名品牌與相關活動將齊聚一堂。讓我們再次攜手創造亞洲有史以來最空前的電競盛會。
        .mb-20
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 什麼是 Bring Games To Live？
        p
          | WirForce 2017 今年活動主軸「Bring Games To Live」，深刻實踐「玩家 vs. 遊戲」新世代的緊密關聯。
          br
          | 遊戲因為玩家社群的存在，發展電競、實況、影劇、同人創作、Cosplay 等多元面向，大幅拓寬遊戲作為產品以外的發展可能性；玩家因為遊戲獲得樂趣，進而成為人生志向與生涯發展的重要關鍵。
          br
          | 所有一切都將在 WirForce 2017 獲得實踐，這是屬於玩家的終極遊戲舞台。
        .mb-20
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 活動時間、地點
        h4(style="text-align: center;") 時間：2017 年 11 月 23 日（四）11:00 – 11 月 26 日（日）17:30
        h4(style="text-align: center;") 地點：花博爭艷館
        .mb-4
        div(style="text-align: center;")
          a.btn.ghost-btn(:href="googleCalenderEvent", target="_blank") 加到 Google 行事曆
        .mb-10
        img(v-img:group="{src: ''}", src="~assets/location-map.png", style="display: block; max-width: 100%; margin: 0 auto;")
        .mb-10
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 購票流程
        .process-block-wrap
          .process-block
            img(src="~assets/ticket-process01.png")
            .title 選票
            //- .content Environment, Medicine, Technology, Other Environment, Medicine, Technology, Other Environment, Medicine, Technology, Other Environment, Medicine, Technology, Other
          .process-block
            img(src="~assets/ticket-process02.png")
            .title 付款
            //- .content Environment, Medicine, Technology, Other
          .process-block
            img(src="~assets/ticket-process03.png")
            .title 劃位
            //- .content Environment, Medicine, Technology, Other
        .btn-wrap
          router-link(:to="{name: 'ticketType'}").btn 立即購票
          router-link(:to="{name: 'selectArea'}").btn 劃位 / 座位圖
    section.gamily
      .container
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 WirForce 唯一指定遊戲社群APP
        .gamily-slider-wrap.left(v-on:mouseover="sliderStop = !sliderStop", v-on:mouseout="sliderStop = !sliderStop")
          .gamily-sliders
            img.img-responsive(v-for="(slider, index) in gamilySlider", :src="slider", :class="{'slider-on': sliderOn === index}")
          .gamily-slider-layout
            img.img-responsive(src="~assets/gamily/phone.png")
          .arrows
            .arrow.next(@click="sliderGo('next')")
              i.fa.fa-chevron-right
            .arrow.pre(@click="sliderGo('pre')")
              i.fa.fa-chevron-left
          .slider-dotts
            .title-decoration
              .dot(@click="sliderOn = 0", :class="{ 'actived': sliderOn === 0 }")
              .dot(@click="sliderOn = 1", :class="{ 'actived': sliderOn === 1 }")
              .dot(@click="sliderOn = 2", :class="{ 'actived': sliderOn === 2 }")
              .dot(@click="sliderOn = 3", :class="{ 'actived': sliderOn === 3 }")
        .content-text
          .mb-6
          .text-red WirForce 2017所有最新消息盡在 GAMily！
          .text-white 遊戲 X 實況 X 電競 X 硬體 X 網紅 =  GAMily
          .mb-6
          .text-red 這是一款全新的遊戲社群 APP
          .paragraph-wrap
            .em-title
              .icon-logo
              .text 玩家可以自由創立家族，邀請遊戲與公會中的夥伴一同探索。
            .em-title
              .icon-logo
              .text 發表優質的攻略文與分享文，可讓您有機會獲得其他成員的斗內！
            .em-title
              .icon-logo
              .text 具備聊天室功能，限定家族成員才能進入。
            .em-title
              .icon-logo
              .text 實況名人殺梗、小葵、小嵐...等名人家族跟玩家一同成為夥伴！
          .text-grey
            | 2017年，GAMily 成為 WirForce 大會唯一指定 遊戲社群 APP，目前已經內建 WirForce 大會及 BYOC ⋯等官方家族。
            br
            | 未來的 WirForce 大會資訊、舞台活動、BYOC 活動等等，在 GAMily 都有最即時的更新喔！
            br
            br
            | GAMily遊戲家族募集中，成為遊戲領域的第一個創族者就是你！
            br
            | 在您的手機商店搜尋「 GAMily遊戲社群 」或掃描 QR CODE，加入就是現在！
          .mb-6
          .gamily-link
            a(href="https://gami.ly/c/wirforce?referrer=utm_source%3Dwirforce%26utm_medium%3Dinstall%26utm_campaign%3Dgame_forum_integration", target="_blank")
              img.qrcode(src="~assets/gamily/qrcode.png")
            a(href="https://gami.ly/c/wirforce", target="_blank", style="margin-left: 20px;").btn.ghost-btn.red 前往 Gamily

    section
      .container
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 周邊商品
      .container(style="text-align: center;")
        .mb-8
        router-link(:to="{name: 'shopping'}", target="_blank")
          img(src="~assets/section-shop-banner.jpg", style="max-width: 100%;")
        div(style="text-align: center;")
          router-link.l.btn.ghost-btn.red(:to="{name: 'shopping'}", target="_blank") BUY IT

    section
      .container
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 節目表
        programList
    section.gallery
      .container
        .title-decoration
          .dot
          .dot
          .dot
          .dot
        h1 精彩花絮
        .lightbox.row
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery01.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery02.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery03.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery04.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery05.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery06.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery07.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery08.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery09.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery10.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery11.jpg")
          img.col-md-3.col-xs-6(v-img:gallery="{src: ''}" src="~assets/gallery/gallery12.jpg")
    .mb-20
    .pop-banner(v-if="popBanner && isMobile")
      .pop-content
        router-link(:to="{name: 'shopping'}", target="_blank")
          img(src="~assets/banner-shop-mobile.jpg", style="max-width: 100%;")
        .btn.pop-close(@click="popBanner = !popBanner") CLOSE
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'
import humanImg from 'assets/bg-human.png'
import titleImage from 'assets/home-title.png'
import slider01 from 'assets/gamily/gamily01.png'
import slider02 from 'assets/gamily/gamily02.png'
import slider03 from 'assets/gamily/gamily03.png'
import slider04 from 'assets/gamily/gamily04.png'
import programList from './programList'
import moment from 'moment'
export default {
  name: 'homepage',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
      console.log('leave')
      window.removeEventListener('resize', () => {
        this.placeImages()
      }, false)
    })
  },
  components: {
    programList
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    let now = moment(new Date()).format('x')
    let wirforceOpening = moment(new Date('November 23, 2017 11:00:00')).format('x')
    console.warn(now, wirforceOpening, wirforceOpening - now)
    return {
      countDownTimer: wirforceOpening - now,
      nowTab: 0,
      days: ['11/23 (四)', '11/24 (五)', '11/25 (六)', '11/26 (日)'],
      videoSwitch: true,
      videoWidth: '',
      videoHeight: '',
      homeImages: {
        humanImage: humanImg,
        titleImage: titleImage
      },
      popBanner: true,
      nowScrollTop: 0,
      googleCalenderEvent: 'https://www.google.com/calendar/render?action=TEMPLATE&text=2017+Wirforce&dates=20171122T160000Z/20171126T173000Z&details=2017+Wirforce+正式啟動+更多資訊:+http://www.wirforce.com.tw&location=花博公園爭艷館&sf=true&output=xml',
      gamilySlider: [
        slider01,
        slider02,
        slider03,
        slider04
      ],
      sliderOn: 0,
      timer: 0,
      sliderStop: true
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
    // Images' Position placement
    placeImages () {
      setTimeout(() => {
        const bgHuman = document.getElementById('bg-human')
        const bgTitle = document.getElementById('bg-title')
        if (this.isMobile) {
          if (this.isPortrait) {
            bgHuman.height = this.fullScreenCount.innerHeight * 0.7
            bgTitle.style.bottom = bgHuman.height / 5 + 'px'
          } else {
            bgHuman.height = this.fullScreenCount.innerHeight * 0.85
            bgTitle.style.bottom = bgHuman.height / 2 * 0.9 + 'px'
          }
        } else {
          // Place bgTitle at center
          bgHuman.height = this.fullScreenCount.innerHeight * 0.95
          bgTitle.style.bottom = bgHuman.height / 2 - 100 + 'px'
        }
      }, 1)
    },
    preventDefault (e) {
      e = e || window.event
      if (e.preventDefault) {
        e.preventDefault()
      }
      e.returnValue = false
    },
    preventDefaultForScrollKeys (e) {
      let keys = {37: 1, 38: 1, 39: 1, 40: 1}
      if (keys[e.keyCode]) {
        this.preventDefault(e)
        return false
      }
    },
    autoplay () {
      const self = this
      function setTimer () {
        return setInterval(() => {
          if (self.sliderStop === true) {
            self.sliderOn ++
          }
          if (self.sliderOn === 4) {
            self.sliderOn = 0
          }
        }, 3000)
      }
      if (this.timer) clearInterval(this.timer)
      this.timer = setTimer()
    },
    sliderGo (action) {
      if (action === 'next') {
        if (this.sliderOn < 3) {
          this.sliderOn ++
        } else {
          this.sliderOn = 0
        }
      }
      if (action === 'pre') {
        if (this.sliderOn === 0) {
          this.sliderOn = 3
        } else {
          this.sliderOn --
        }
      }
    }
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      this.$parent.setSectionHeight()
      this.placeImages()
    })

    // Place images after resize
    if ('removeEventListener' in window) {
      window.addEventListener('resize', () => {
        if (this.$route.name === 'homepage') {
          this.placeImages()
        } else {
          console.log('123')
        }
      }, false)
    }
    this.autoplay()
    console.log(this.sliderOn)
    if (this.fullScreenCount.innerWidth > this.fullScreenCount.innerHeight) {
      this.videoWidth = this.fullScreenCount.innerWidth - 600
      this.videoHeight = (this.fullScreenCount.innerWidth - 600) / 1.7777
    } else {
      this.videoWidth = this.fullScreenCount.innerWidth
      this.videoHeight = this.fullScreenCount.innerWidth / 1.7777
    }
  },
  watch: {
  },
  updated () {
    if (this.fullScreenCount.innerWidth > this.fullScreenCount.innerHeight) {
      this.videoWidth = this.fullScreenCount.innerWidth - 600
      this.videoHeight = (this.fullScreenCount.innerWidth - 600) / 1.7777
    } else {
      this.videoWidth = this.fullScreenCount.innerWidth
      this.videoHeight = this.fullScreenCount.innerWidth / 1.7777
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.placeImages()
    }, false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
@font-face
  font-family: Airstrike;
  src: url(~assets/airstrike.ttf)
.countDownTimer
  text-align: center
  margin: 0 auto
  display: block
  width: 100%
  .timerText
    font-size: 22px
    color: $grey
    font-style: italic
    @media screen and (max-width: 640px)
      display: block
      font-size: 20px
  .timerNum
    font-size: 80px
    font-family: 'Airstrike'
    padding: 0 20px
    color: $red
    @media screen and (max-width: 640px)
      font-size: 60px
      display: block
.home
  position: relative
  overflow: hidden
  background:
    image: url('~assets/bg-home.png')
    size: cover
    repeat: no-repeat
    position: center bottom
  #bg-human
    position: absolute
    bottom: 0
    left: 50%
    +transform(translateX(-50%))
    // +transition(all, 0.5s, ease)
  #bg-title
    position: absolute
    margin-left: 5%
    left: 50%
    +transform(translateX(-50%))
    +transition(all, 0.3s, ease)
    max-width: 200%
  .btn-scroll
    position: absolute
    bottom: 32px
    left: 50%
    +transform(translateX(-50%))
    +transition(all, 0.3s, ease)
    +animation('breathing-light 3s infinite')
.buying-process
  background:
    image: url("~assets/bg-section02.png")
    repeat: no-repeat
    size: auto 100%
  .process-block-wrap
    display: flex
    flex-flow: row wrap
    justify-content: space-around
    align-items: flex-start
    align-content: stretch
    .process-block
      width: 30%
      margin-bottom: 48px
      text-align: center
      @media screen and (max-width: 640px)
        width: 100%
      img
        max-width: 206px
      .title
        font-size: 18px
        font-weight: bold
        margin: 8px 0 4px 0
        text-align: center
      .content
        font-size: 13px
        text-align: left

  .btn-wrap
    text-align: center
    margin:
      top: 32px
      bottom: 128px
    @media screen and (max-width: 640px)
      margin:
        top: 64px
        bottom: 64px
    .btn
      margin: 6px 48px
      padding: 8px 24px
      border: 1px solid $red
      +border-radius(999px)
      color: $red
      font-size: 16px
      background:
        color: transparent
      @media screen and (max-width: 640px)
        margin: 0 0 32px 0
        width: 100%
      +transition(all, 0.3s, ease)
      &:hover
        color: $black
        background:
          color: $red
        box-shadow: 0 0 13px 2px $red
.gallery
  .lightbox
    img
      margin: 16px 0

.banner-shop
  position: fixed
  bottom: 3px
  right: 8px
  z-index: 99
  div, a
    +transition(filter, 0.3s, ease)
    &:hover
      -webkit-filter: drop-shadow(0px 0px 5px rgba($red, 0.8))
      filter: drop-shadow(0px 0px 5px rgba($red, 0.8))
  @media screen and (max-width: 640px)
    display: none

.pop-banner
  position: fixed
  top: 0
  left: 0
  background: rgba(0,0,0,0.85)
  width: 100%
  height: 100vh
  z-index: 100
  .pop-content
    position: relative
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    width: 320px
    img
      background-color: #000
    .pop-close
      color: $black
      background-color: $red
      // border: 1px solid $red
      display: inline-block
      position: relative
      left: 50%
      transform: translateX(-50%)
      padding: 8px 20px
      margin-right: 3px
      margin-top: 8px
.gamily
  @extend %clearfix
  .content-text
    width: 67%
    padding-left: 30px
    float: left
    @media screen and (max-width: 640px)
      width: 100%
    .text-red
      color: $red
    .text-white
      color: #fff
    .text-grey
      color: $grey
    .gamily-link
      .qrcode
        img
          display: block
        @media screen and (max-width: 640px)
          display: block
          margin: 0 auto
          margin-bottom: 30px
.gamily-slider-wrap
  position: relative
  width: 33%
  float: left
  @media screen and (max-width: 640px)
    width: 70%
    float: none
    margin: 20px auto
  .gamily-slider-layout
    position: relative
  .arrows
    position: absolute
    top: 50%
    transform: translateY(-80%)
    width: 100%
    .arrow
      cursor: pointer
      font-size: 60px
      background-color: rgba($black, 0.8)
      width: 80px
      height: 80px
      text-align: center
      opacity: 0.3
      +transition(all, 0.3s, ease)
      &.pre
        float: left
        margin-left: -10%
      &.next
        float: right
        margin-right: -10%
    &:hover
      .arrow
        opacity: 1
        &.pre
          margin-left: 0%
        &.next
          margin-right: 0%
  .gamily-sliders
    position: absolute
    width: 100%
    height: 100%
    img
      opacity: 0
      position: absolute
      top: 0
      +transition(all, 0.3s, ease)
    .slider-on
      opacity: 1
  .slider-dotts
    .title-decoration
      margin-top: 0
      .dot
        cursor: pointer
        opacity: 0.3
        +transition(all, 0.3s, ease)
        &.actived
          +transform(scale(1.5))
          opacity: 1
        &:hover
          +transform(scale(1.5))
.video-pop
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  z-index: 999
  .bg
    background-color: rgba(black, 0.75)
    width: 100%
    height: 100%
  .video-wrap
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    iframe
      position: relative
      margin: 0 auto
    .video-close
      position: absolute
      bottom: -40px
      left: 50%
      transform: translateX(-50%)
      background-color: $red
      color: $black
      padding: 6px 12px
      text-transform: uppercase
      font-weight: bold
      font-size: 16px
      +border-radius(3px)
      cursor: pointer
</style>



// WEBPACK FOOTER //
// homepage.vue?ddc9c0e4